import { Icon20CloudArrowUpOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { type FC, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAiPhotoGenerationSaved } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.actions';
import { getAiPhotoGenerationSaved } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.selectors';

import styles from './AiPhotoGenerationButtonSave.css';

interface IProps {
    onClick: () => void;
}

export const AiPhotoGenerationButtonSave: FC<IProps> = memo(function AiPhotoGenerationButtonSave(props) {
    const { onClick } = props;

    const saved = useSelector(getAiPhotoGenerationSaved);

    const dispatch = useDispatch();

    const handleClick = () => {
        onClick();
        dispatch(setAiPhotoGenerationSaved());
    };

    if (saved) {
        return <div className={classNames(styles.wrapper, styles.wrapper_none)} />;
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.button} onClick={handleClick}>
                <Icon20CloudArrowUpOutline data-qa-id="again-icon" />
                Сохранить в Облако
            </div>
        </div>
    );
});
